import { render, staticRenderFns } from "./UploadPrimisReport.vue?vue&type=template&id=7b39a0e8&scoped=true"
import script from "./UploadPrimisReport.vue?vue&type=script&lang=js"
export * from "./UploadPrimisReport.vue?vue&type=script&lang=js"
import style0 from "./UploadPrimisReport.vue?vue&type=style&index=0&id=7b39a0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39a0e8",
  null
  
)

export default component.exports